import { Action } from '@ngrx/store';


export enum AdmDatosTActionTypes {
  GET_ADM_DATOST = '[ADM_MODELO] GetDatosT',
  SET_ADM_DATOST = '[ADM_MODELO] SetDatosT',
  EDIT_ADM_DATOST = '[ADM_MODELO] EditDatosT',
  DELETE_ADM_DATOST = '[ADM_MODELO] DeleteDatosT',
  SUCESS_DATOST = '[ADM_MODELO] SuccessDatosT',
  FAIL_DATOST = '[ADM_MODELO] FailDatosT',
}

export class AdmGetDatosT implements Action {
  readonly type = AdmDatosTActionTypes.GET_ADM_DATOST;
  constructor() {}
}

export class AdmSetDatosT implements Action {
  readonly type = AdmDatosTActionTypes.SET_ADM_DATOST;
  constructor(public DatosTabulares: any) {}
}
export class AdmEditDatosT implements Action {
  readonly type = AdmDatosTActionTypes.EDIT_ADM_DATOST;
  constructor(public DatosTabulares: any) {}
}

export class AdmDeleteDatosT implements Action {
  readonly type = AdmDatosTActionTypes.DELETE_ADM_DATOST;
  constructor(public ObjDel: any) {}
}

export class AdmSuscessDatosT implements Action {
  readonly type = AdmDatosTActionTypes.SUCESS_DATOST;
  constructor(public Respuesta: any , public TipoR: string) {}
}

export class AdmFailDatosT implements Action {
  readonly type = AdmDatosTActionTypes.FAIL_DATOST;
  constructor(public Respuesta: any) {}
}


export type AdmDatosTAcciones =
    | AdmGetDatosT
    | AdmSetDatosT
    | AdmEditDatosT
    | AdmDeleteDatosT
    | AdmSuscessDatosT
    | AdmFailDatosT;
